import { setupHelpers } from './helpers.js'
import { setupState } from './state.js'
import { registerServiceWorkers } from './serviceworker.js'
import { setupOnlineStatus } from './onlinestatus.js'
import { makeInstallable } from './installable.js'
import { lockOrientation } from './orientation.js'
import * as Sentry from "@sentry/browser";

import Vue from 'vue'
import Scanner from './Scanner.vue'
import rfidService from './rfidService.js'

setupHelpers()
setupState()
registerServiceWorkers()
setupOnlineStatus()
lockOrientation()

const scanner = window.scanner
Vue.prototype.$scanner = window.scanner

scanner.debugging = false
scanner.registered = false

scanner.api_server = process.env.VUE_APP_API_SERVER
scanner.enable_square = Boolean(process.env.VUE_APP_SQUARE_ENABLED && process.env.VUE_APP_SQUARE_ENABLED.toLowerCase() === "true")
scanner.enable_cash = process.env.VUE_APP_CASH_ENABLED !== "false"

window.resizeTo(320, 600)
window.makeInstallable = makeInstallable

if(process.env.VUE_APP_SENTRY_DSN) {
	Sentry.init({
		Vue,
		dsn: process.env.VUE_APP_SENTRY_DSN,
		environment: process.env.VUE_APP_ENV,
		debug: false,
		maxValueLength: 4096,

		// Session Replay
		replaysSessionSampleRate: process.env.VUE_APP_ENV === "production" ? 0 : 1, // 0 will disable continuous recording. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

		// Performance Monitoring
		integrations: [
			Sentry.breadcrumbsIntegration({
				console: true,
				fetch: true,
				xhr: true,
			}),
			Sentry.captureConsoleIntegration({ levels: ['error', 'warn'] }),
			Sentry.replayIntegration({
				maskAllText: false,
				maskAllInputs: false,
			}),
		],
	});
}

window.testSentry = function() {
	const msg =
		"This is a console error log for testing. Sentry is working as expected. " +
		"This is a console error log for testing. Sentry is working as expected. " +
		"This is a console error log for testing. Sentry is working as expected. " +
		"This is a console error log for testing. Sentry is working as expected."
	console.error(msg)
	undefinedFuncForTesting()
}

// note: this app receives realtime connection status from the device or browser, but the polling is to check if it can connect to our servers not just if it is online and is now a secondary check hence the 30sec interval.  realtime connection switching happens on the fly.
// window.connection.check_interval = 30 // in seconds
// Vue.prototype.$scanner_heartbeat = setInterval(window.connection.checkConnection, 1000 * window.connection.check_interval);

scanner.app = new Vue({ render: h => h(Scanner), provide: {rfidService} }).$mount('#scanner')
